module.exports = __webpack_public_path__ + "img/bridge-normal.0b985ef1.svg";